import { Link } from "gatsby";
import gsap from "gsap";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import { SafeHtmlParser } from "./SafeHtmlParser";

const GridLayout2 = ({ heading, items }) => {
	const handleMouseEnter = (e, colour) => {
		gsap.to(e.target, { color: colour, duration: 0.1 });
	};

	const handleMouseLeave = (e) => {
		gsap.to(e.target, { color: "#000", duration: 0.1 });
	};

	return (
		<section className="py-5 py-lg-7">
			<Container>
				{/* Heading */}
				<Row className="text-center mb-5">
					<Col>
						<SafeHtmlParser htmlContent={heading} />
					</Col>
				</Row>

				{/* Services Grid */}
				<Row className="g-4">
					{items.map((item, index) => {
						const image = item.icon?.sourceUrl;

						return (
							<Col lg={index < 3 ? 4 : 6} xs={12} key={index}>
								<div
									className="p-4 h-100"
									style={{
										border: "1px solid #CEE4FF",
										borderRadius: "12px",
										background: "#fff",
									}}
								>
									{/* Icon and Title */}
									<Row className="pb-5 h-100 position-relative">
										<Col xs={12} md={5} lg={index < 3 ? 12 : 6}>
											{image && (
												<div className="mb-2" style={{ height: "40px" }}>
													<img
														src={image}
														alt={item.icon.altText}
														style={{ width: "40px" }}
													/>
												</div>
											)}
											<h3
												className="mb-3"
												style={{
													color: item.colour,
												}}
											>
												{item.heading}
											</h3>
											{index > 2 && (
												<div className="d-none d-lg-flex align-items-center">
													<Link
														onMouseEnter={(e) =>
															handleMouseEnter(e, item.colour)
														}
														style={{ color: "black" }}
														onMouseLeave={handleMouseLeave}
														className="outfit-regular text-decoration-none  mb-0 pb-0"
														to={item.url}
													>
														Find Out More{" "}
													</Link>
													<span style={{ color: item.colour }}>
														<MdKeyboardArrowRight className="fs-5 ms-1" />
													</span>
												</div>
											)}
											<div className="d-flex d-lg-none align-items-center mb-3">
												<Link
													onMouseEnter={(e) => handleMouseEnter(e, item.colour)}
													style={{ color: "black" }}
													onMouseLeave={handleMouseLeave}
													className="outfit-regular text-decoration-none  mb-0 pb-0"
													to={item.url}
												>
													Find Out More{" "}
												</Link>
												<span style={{ color: item.colour }}>
													<MdKeyboardArrowRight className="fs-5 ms-1" />
												</span>
											</div>
										</Col>
										<Col xs={12} md={5} lg={index < 3 ? 12 : 6}>
											{/* Services List */}
											<ul
												className="mb-0"
												style={{
													listStyle: "none",
													padding: 0,
												}}
											>
												{item.listItems.map((listItem, i) => (
													<li
														key={i}
														className="mb-2 d-flex align-items-center"
														style={{ color: "#000" }}
													>
														<MdKeyboardArrowRight
															className="me-1 fs-5"
															style={{
																color: item.colour,
															}}
														/>

														{listItem.heading}
													</li>
												))}
											</ul>
											{index < 3 && (
												<div className="d-none mt-3  d-lg-flex align-items-center position-absolute bottom-0">
													<Link
														onMouseEnter={(e) =>
															handleMouseEnter(e, item.colour)
														}
														style={{ color: "black" }}
														onMouseLeave={handleMouseLeave}
														className="outfit-regular text-decoration-none  mb-0 pb-0"
														to={item.url}
													>
														Find Out More{" "}
													</Link>
													<span style={{ color: item.colour }}>
														<MdKeyboardArrowRight className="fs-5 ms-1" />
													</span>
												</div>
											)}
										</Col>
									</Row>
								</div>
							</Col>
						);
					})}
				</Row>
			</Container>
		</section>
	);
};

export default GridLayout2;
